import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Store } from "lucide-react";

const isAdmin = () => { try { return ["super_admin", "brand_admin"].includes(JSON.parse(localStorage.getItem("kazo_user") || "{}").role); } catch { return false; } };

export const RecoUnknownStores = ({ analysis, onDone }) => {
  const [busy, setBusy] = useState(false);
  const codes = analysis.unknown_store_codes || [];
  const meta = analysis.store_meta || {};
  const created = analysis.stores_created || [];
  if (!codes.length && !created.length) return null;

  const label = `${codes.length} ${codes.length === 1 ? "store" : "stores"}`;

  const create = async () => {
    if (!window.confirm(`Add ${label} to the Store Master using the names from the file?`)) return;
    setBusy(true);
    try {
      const r = await api.post(`/reco/invoice/analyses/${analysis.id}/create-stores`, { codes });
      toast.success(`${r.data.created.length} stores added`);
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not add stores"); }
    finally { setBusy(false); }
  };

  return (
    <div className={`border p-3 text-xs space-y-2 ${codes.length ? "border-rose-200 bg-rose-50/40" : "border-emerald-200 bg-emerald-50/40"}`} data-testid="reco-unknown-stores">
      {codes.length > 0 && (
        <>
          <div className="text-rose-700">{codes.length} store {codes.length === 1 ? "code" : "codes"} in the file {codes.length === 1 ? "is" : "are"} not in the Store Master:</div>
          <div className="flex flex-wrap gap-1.5">
            {codes.map((c) => <span key={c} className="bg-white border border-black/10 px-1.5 py-0.5"><span className="font-mono">{c}</span> {meta[c]?.name}{meta[c]?.state ? ` · ${meta[c].state}` : ""}</span>)}
          </div>
          {isAdmin() && (
            <button onClick={create} disabled={busy} className="k-btn k-btn-sm kazo-bg-burgundy text-white" data-testid="reco-create-stores-btn">
              <Store className="w-3.5 h-3.5" /> {busy ? "Adding…" : `Add ${label}`}
            </button>
          )}
        </>
      )}
      {created.length > 0 && <div className="text-emerald-700" data-testid="reco-stores-created">Added: {created.map((c) => c.code).join(", ")} — edit city/address in Stores.</div>}
    </div>
  );
};
